/*
 * Gleich grosse Motive in den Menue-Kacheln.
 * Die Kategoriebilder haben unterschiedliche Seitenverhaeltnisse und
 * unterschiedlich viel Rand um das Motiv. Wir messen den sichtbaren
 * Motivbereich auf einem kleinen Canvas und zoomen jedes Bild so, dass das
 * Motiv in jeder Kachel etwa gleich gross und mittig sitzt.
 */
(function () {
  if (window.pawsMenuThumbs) return;
  window.pawsMenuThumbs = true;

  var FUELLGRAD = 0.92; // Anteil der Kachel, den die laengste Motivkante einnehmen soll
  var MAX_ZOOM = 2.6;
  var MESSBREITE = 72; // Canvas-Kantenlaenge fuer die Messung
  var SPEICHER = 'pawsMenuThumbs';
  var cache = ladeCache();

  function ladeCache() {
    try {
      return JSON.parse(sessionStorage.getItem(SPEICHER)) || {};
    } catch (e) {
      return {};
    }
  }

  function speichereCache() {
    try {
      sessionStorage.setItem(SPEICHER, JSON.stringify(cache));
    } catch (e) {
      /* Speicher voll oder gesperrt: dann eben ohne Cache. */
    }
  }

  function kleineUrl(url) {
    try {
      var u = new URL(url, location.href);
      u.searchParams.set('width', '160');
      u.searchParams.delete('height');
      return u.href;
    } catch (e) {
      return url;
    }
  }

  // Liefert den Motivbereich in Bildanteilen (0..1) oder null.
  function messeMotiv(bild) {
    var iw = bild.naturalWidth;
    var ih = bild.naturalHeight;
    if (!iw || !ih) return null;

    var w = Math.max(1, Math.round(iw >= ih ? MESSBREITE : (MESSBREITE * iw) / ih));
    var h = Math.max(1, Math.round(ih >= iw ? MESSBREITE : (MESSBREITE * ih) / iw));

    var canvas = document.createElement('canvas');
    canvas.width = w;
    canvas.height = h;
    var ctx = canvas.getContext('2d', { willReadFrequently: true });
    ctx.drawImage(bild, 0, 0, w, h);

    var daten;
    try {
      daten = ctx.getImageData(0, 0, w, h).data;
    } catch (e) {
      return null; // Canvas ist "tainted" (kein CORS-Header)
    }

    function pixel(x, y) {
      var i = (y * w + x) * 4;
      return [daten[i], daten[i + 1], daten[i + 2], daten[i + 3]];
    }

    var ecken = [pixel(0, 0), pixel(w - 1, 0), pixel(0, h - 1), pixel(w - 1, h - 1)];
    var transparent = ecken.filter(function (p) { return p[3] < 24; }).length >= 3;
    var hg = [0, 0, 0];
    ecken.forEach(function (p) { hg[0] += p[0] / 4; hg[1] += p[1] / 4; hg[2] += p[2] / 4; });

    var minX = w, minY = h, maxX = -1, maxY = -1;
    for (var y = 0; y < h; y++) {
      for (var x = 0; x < w; x++) {
        var p = pixel(x, y);
        var motiv = transparent
          ? p[3] > 24
          : p[3] > 24 && Math.abs(p[0] - hg[0]) + Math.abs(p[1] - hg[1]) + Math.abs(p[2] - hg[2]) > 42;
        if (!motiv) continue;
        if (x < minX) minX = x;
        if (x > maxX) maxX = x;
        if (y < minY) minY = y;
        if (y > maxY) maxY = y;
      }
    }
    if (maxX < 0) return null;

    var box = {
      x: minX / w,
      y: minY / h,
      w: (maxX - minX + 1) / w,
      h: (maxY - minY + 1) / h,
      iw: iw,
      ih: ih
    };
    if (box.w * box.h < 0.02) return null; // unplausibel klein -> lieber nichts tun
    return box;
  }

  function wendeAn(el, box) {
    // Custom Property statt Messung: das Menue ist beim Berechnen oft noch display:none.
    var seite = parseFloat(getComputedStyle(el).getPropertyValue('--paws-thumb')) || el.clientWidth;
    if (!seite) return;

    // object-fit: contain -> so wird das Bild in der quadratischen Kachel gerendert
    var basis = seite / Math.max(box.iw, box.ih);
    var breiteGerendert = box.iw * basis;
    var hoeheGerendert = box.ih * basis;

    var motivBreite = box.w * breiteGerendert;
    var motivHoehe = box.h * hoeheGerendert;
    var zoom = Math.min(MAX_ZOOM, (seite * FUELLGRAD) / Math.max(motivBreite, motivHoehe));

    var versatzX = -((box.x + box.w / 2) - 0.5) * breiteGerendert * zoom;
    var versatzY = -((box.y + box.h / 2) - 0.5) * hoeheGerendert * zoom;

    el.style.transform =
      'translate(' + versatzX.toFixed(2) + 'px,' + versatzY.toFixed(2) + 'px) scale(' + zoom.toFixed(3) + ')';
  }

  function verarbeite(el) {
    if (el.dataset.pawsThumb) return;
    el.dataset.pawsThumb = '1';

    var quelle = el.currentSrc || el.src;
    if (!quelle) return;

    var schluessel = quelle.split('?')[0];
    if (cache[schluessel]) {
      wendeAn(el, cache[schluessel]);
      return;
    }

    var probe = new Image();
    probe.crossOrigin = 'anonymous';
    probe.decoding = 'async';
    probe.onload = function () {
      var box = messeMotiv(probe);
      if (!box) return;
      cache[schluessel] = box;
      speichereCache();
      wendeAn(el, box);
    };
    probe.src = kleineUrl(quelle);
  }

  function durchlauf() {
    document.querySelectorAll('#sub-hdt-nav-mb .hdt-category-img img').forEach(verarbeite);
  }

  // Der Beobachter hing frueher am gesamten <body> mit subtree: true. Auf einer
  // Produktseite baut der Personalisierer laufend DOM um - dadurch lief der
  // Rueckruf praktisch in jedem Bild, und jedes Mal ging eine Suche ueber das
  // ganze Dokument. Beobachtet wird jetzt nur das Menue selbst. Bis es im DOM
  // ist, wartet ein einzelner Beobachter am <body> darauf und gibt sich danach
  // selbst auf - so bleibt am Ende nur der kleine, enge Beobachter uebrig.
  var MENUE = '#sub-hdt-nav-mb';

  function beobachte(ziel) {
    var geplant = false;
    new MutationObserver(function () {
      if (geplant) return;
      geplant = true;
      requestAnimationFrame(function () {
        geplant = false;
        durchlauf();
      });
    }).observe(ziel, { childList: true, subtree: true });
  }

  function start() {
    durchlauf();

    var menue = document.querySelector(MENUE);
    if (menue) {
      beobachte(menue);
      return;
    }

    // Untermenues werden teils nachgeladen, das Menue selbst erst beim Oeffnen
    // aufgebaut - deshalb ein Wartebeobachter, aber nur bis es einmal da ist.
    var warte = new MutationObserver(function () {
      var m = document.querySelector(MENUE);
      if (!m) return;
      warte.disconnect();
      durchlauf();
      beobachte(m);
    });
    warte.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
